import React from "react";
import Context from "../../../../../context";
import dictionary from "../../../../../dictionary";

import {
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../../components";
import { useTranslation } from "react-i18next";

const ParentInformation = () => {
  const { showModal, setShowModal, selectedUser } = React.useContext(
    Context.ServiceScreen
  );

  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"40vw"}
        maxWidth={"50vw"}
        open={showModal === "SHOW_PARENT_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <UserInformation
            avatar={selectedUser?.avatar}
            name={
              selectedUser?.firstName
                ? selectedUser?.firstName
                : selectedUser?.name
            }
            lastName={selectedUser?.lastName ? selectedUser?.lastName : ""}
            phoneNumber={
              selectedUser?.phoneNumber
                ? selectedUser?.phoneNumber
                : selectedUser?.telephone
            }
            isBlock={null}
          />
          <hr />
          <CustomView.Row className="form-column-row">
            {selectedUser?.gender && (
              <CustomView.Column
                medium={8}
                small={12}
                className="form-values form-column"
              >
                <label className="form-label">{t("gender")} :</label>
                <p>{dictionary.genderEnglish2Persian(selectedUser?.gender)}</p>
              </CustomView.Column>
            )}
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default ParentInformation;
